function parseLocaleToJsObject(encodedString) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = encodedString;
    const decodedString = tempElement.textContent || tempElement.innerText;
    const jsonCompatibleString = decodedString.replaceAll('=>', ':');
    const sanitizedJSON = jsonCompatibleString.replace(/:"([^.]*?.)."(?=\s*[},])/g, (match, group1) => {
        const modifiedGroup = group1.replace(/"/g, '\\"');
        return match.replace(group1, modifiedGroup);
    });

    return JSON.parse(sanitizedJSON, (key, value) => {
        return typeof value === 'string' ? value.replace('\"', '"') : value;
    });
}